/*
 * @Author: ningbo.kang
 * @Date: 2019-11-27 14:12:57
 * @LastEditors: ningbo.kang
 * @LastEditTime: 2019-11-27 15:28:12
 * @FilePath: /template/src/store/modules/system/notice.js
 * @Description: 描述
 */
import dbNotice from '@/api/system/notice';

const user = {
  namespaced: true,
  state: {},
  getters: {},

  mutations: {
    // 设置错误次数，大于3次数，出现验证码
    // setNotice: (state, count) => {},
  },

  actions: {
    /**
     * 登录
     * @param {*} store
     * @param {*} userInfo
     */
    getNotice(context, param) {
      return dbNotice.getNotice(param).then(res => res.list);
    },
    getInformation(context, param) {
      return dbNotice.getInformation(param).then(res => res.list);
    },
    getTodo(context, param) {
      return dbNotice.getTodo(param).then(res => res.list);
    },
    count(context, param) {
      return dbNotice.getCount(param).then(res => res.data.count);
    },
  },
};

export default user;
